import * as React from 'react';

import EnterpriseSearchProviderWrapper from 'bundles/enterprise-learner-search/providers/EnterpriseSearchProviderWrapper';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterpriseSearchPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  const program = useProgram();
  const features = useEnterpriseProductFeatures();

  if (!program) {
    return null;
  }

  return (
    <EnterpriseSearchProviderWrapper
      searchContext={{ searchInPrograms: { programIds: [program.id] } }}
      shouldEnableShortFormContent={!!features?.allowShortFormContentBasedOnAudience}
    >
      {children}
    </EnterpriseSearchProviderWrapper>
  );
};

export default EnterpriseSearchPageDataProvider;
